// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import { AlertPlugin, ToastPlugin ,ConfirmPlugin } from 'vux'
import AlertPlugin from 'vux/src/plugins/alert'
import ToastPlugin from 'vux/src/plugins/toast'
import ConfirmPlugin from 'vux/src/plugins/confirm'
import LoadingPlugin from 'vux/src/plugins/loading'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import VueLazyLoad from 'vue-lazyload'
import InfiniteLoading from 'vue-infinite-loading';
import VueClipboard from 'vue-clipboard2'

import {EpetJs} from '@/utils/epetsdk'
import store from '@/store/index'
import headerbar from '@/components/headerbar/headerbar'
import wx from 'weixin-js-sdk'
Vue.component('headerbar', headerbar)
Vue.component('InfiniteLoading', InfiniteLoading)

Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)
Vue.use(VueLazyLoad,{
    error:'/images/loading.png',
    loading:'/images/loading.png'
})
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']
Vue.prototype.$EpetJs = EpetJs;
Vue.prototype.$wx =wx;
// const FastClick = require('fastclick')
// FastClick.attach(document.body)
import './assets/css/public.css'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})
